import React from 'react';
import { initialState, reducer } from './reducer';
import { applyTheme, getStoredTheme, persistTheme } from './theme-utils';

export const ThemeContext = React.createContext([initialState, () => null]);

export const ThemeProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  React.useEffect(() => {
    applyTheme(state.theme);
  }, [state.theme]);

  // While the user has not chosen, follow OS theme changes live.
  React.useEffect(() => {
    let mq;
    try {
      mq = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    } catch (_) {}
    if (!mq || !mq.addEventListener) return undefined;
    const onChange = (e) => {
      if (!getStoredTheme()) dispatch({ type: 'set', payload: e.matches ? 'dark' : 'light' });
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  // User actions persist; OS-driven 'set' goes through the raw dispatch above.
  const userDispatch = React.useCallback(
    (action) => {
      if (action.type === 'toggle') {
        persistTheme(state.theme === 'dark' ? 'light' : 'dark');
      } else if (action.type === 'set') {
        persistTheme(action.payload);
      }
      dispatch(action);
    },
    [state.theme]
  );

  return (
    <ThemeContext.Provider value={[state, userDispatch]}>
      {children}
    </ThemeContext.Provider>
  );
};
